import { paygEndpoints } from '@/src/constants/endpoints';
import { apiService } from '@/src/services/api-service';
import { useAccountContext } from '@ovotech/ui-tools';
import { useMutation } from 'react-query';
import { paygQueryKeys } from './queryKeys';
import { TopupInitiateRequest, TopupInitiateResponse } from './types';

export const useInitiateTopupMutation = () => {
  const { accountId } = useAccountContext();

  return useMutation({
    retry: 1,
    mutationFn: (body: TopupInitiateRequest) =>
      apiService.post<TopupInitiateResponse>({
        url: paygEndpoints.topups(accountId!),
        body,
      }),
    mutationKey: paygQueryKeys.initiateTopup(accountId || ''),
  });
};
